<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>tag</md-icon>
          </div>
          <h4 class="title">Edit Role: {{ role.name }}</h4>
        </md-card-header>

        <form @submit.prevent="update">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Name
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="role.name"/>
                  <validation-error :errors="apiValidationErrors.name"/>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Group
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="role.group"/>
                </md-field>
                <validation-error :errors="apiValidationErrors.group"/>
              </div>
            </div>
            <md-table v-model="permissions" md-card>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Description" md-sort-by="title">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Add/Remove" md-sort-by="title">
                  <md-switch v-model="selected_ids" :id="'permissions'+item.id" :value="item.id"
                             @change="updatePermission(item.id)"></md-switch>
                </md-table-cell>
              </md-table-row>
              <md-table-pagination
                  :md-page-size="5"
                  :md-page-options="[5,10,15,20,25,30]"
                  :md-update="updatePagination"
                  :md-data="permissions"
                  :md-paginated-data.sync="paginatedUsers"/>
            </md-table>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Update Role</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import {ValidationError} from '@/components';
import formMixin from '@/mixins/form-mixin';
// import Multiselect from 'vue-multiselect'
export default {
  components: {ValidationError},// Multiselect
  name: 'TableMultiple',

  mixins: [formMixin],

  data: () => ({
    selected_ids: [],
    paginatedUsers: [],
    role: {
      name: null,
      type: 'role',
      permissions: []
    },
    permissionData: {
      type: 'permissions',
      name: null,
      id: null,
      guard_name: null,
      updated_at: null,
      created_at: null
    },
    permissions: [],
    selected: [],
    available_permissions: [],
  }),

  created() {
    this.get();
    this.getPermissions();
  },

  methods: {
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = '';

      if (count > 1) {
        plural = 's';
      }

      return `${count} user${plural} selected`;
    },
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch('roles/get', id);
        this.role = this.$store.getters['roles/role'];
        this.selected_ids = [];
        this.role.permissions.forEach(p => {
          this.selected_ids.push(p.id);
        });
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },

    async update() {
      try {
        await this.$store.dispatch('roles/update', this.role);
        await this.$store.dispatch(
            'alerts/success',
            'Role updated successfully.'
        );
        this.goBack();
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
              'alerts/error',
              e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong!'
          );
        }
      }
    },

    getPermissions() {
      this.$store.dispatch('permissions/list').then(() => {
        this.permissions = this.$store.getters['permissions/list'];
        this.permissions.forEach(permission => {
          delete permission.links;
        });
      });
    },
    async getRolePermissions() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch('roles/permissions', id);
        this.permissionData = this.$store.getters['roles/permissions'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },

    goBack() {
      this.$router.push({name: 'List Roles'});
    },
    updatePermission(id) {
      // check if id selected if yes add to role.permissions if no remove from role permission
      if (this.selected_ids.includes(id)) {
        const p = this.permissions.find(per => {
          if (per.id === id) {
            return per;
          }
        });
        this.role.permissions.push(p);
      } else {
        const index = this.role.permissions.find((per, ind) => {
          if (per.id === id) {
            return ind;
          }
        });
        this.role.permissions.splice(index, 1);
      }
    },
    updatePagination(page, pageSize, sort, sortOrder) {
      console.log('pagination has updated', page, pageSize, sort, sortOrder);
    }
  },
};
</script>

<style lang="scss" scoped>
.md-table + .md-table {
  margin-top: 16px
}
</style>
